import PropTypes from 'prop-types';
import React__default from 'react';
import { PopoverInternal } from './popover-internal.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const propTypes = {
    expanded: PropTypes.bool,
    position: PropTypes.oneOf([
        'top',
        'right',
        'bottom',
        'left'
    ])
};
const propKeysToRemove = Object.keys(propTypes);
const Popover = renderWithRef('Popover', propTypes, (props, ref)=>{
    const { position , expanded , children  } = props;
    const classNames = [
        'swan-popover-container'
    ];
    return /*#__PURE__*/ React__default.createElement(RenderComp, {
        root: "div",
        forwardedRef: ref,
        classNames: classNames,
        props: props,
        propKeysToRemove: propKeysToRemove
    }, /*#__PURE__*/ React__default.createElement(PopoverInternal, {
        popoverPlacement: position !== null && position !== void 0 ? position : 'top',
        expanded: expanded !== null && expanded !== void 0 ? expanded : undefined
    }, children));
});
Popover.defaultProps = {
    expanded: false,
    position: 'top'
};

export { Popover };
